export const getCurrencySymbol = (currencyCode, currencies = []) => {
    let currency = currencies.find(c => c.currencyCode.toLowerCase() === currencyCode.toLowerCase());
    if(currency){
        return currency.currency?.symbol || currency.currencyCode;
    }
    return currencyCode;
}

export const formatCurrencyWithSymbol = (currencyCode, currencies = [], value, addBrackats = true) => {
    const symbol = getCurrencySymbol(currencyCode, currencies);
    if(addBrackats){
        return `${value} (${symbol})`
    } else {
        return `${value} ${symbol}`
    }
}

export const getCurrencyDecimalCount = (currencyCode, currencies = []) => {
    let currency = currencies.find(c => c.currencyCode.toLowerCase() === currencyCode.toLowerCase() );
    if(currency){
        return currency.currency?.decimalCount ?? 0;
    }
    return 0;
}

export const getRate = (currencyCode, currencies) => {
    const currency = currencies.find(c => c.currencyCode.toLowerCase() === currencyCode.toLowerCase());

    return currency?.currency.rate ?? 1;
}

export const convertCurrencyToDefault = (amount = 0, currencyCode, currencies) => {

    const rate = getRate(currencyCode, currencies);

    return amount * rate;
}

export const convertCurrency = (amount = 0, from, to, currencies) => {

    const rate = getRate(from, currencies);

    return convertCurrencyToDefault(amount/rate, to, currencies);
}